/* eslint no-undef: 0 */
import React from 'react'
import SoompiComponent from 'scripts/components/base/SoompiComponent'
import { soompi } from 'scripts/api/SoompiApi'
import ArticleRender from 'scripts/components/article/ArticleRender'
import FileLoader from 'scripts/helpers/FileLoader'
import ClientErrors from 'scripts/lib/ClientErrors'
import { placeHolders } from 'scripts/helpers/PlaceHolders'
import { extractOrFormInitialData } from 'scripts/helpers/AppHelper'
import SoompiCommon from 'scripts/components/SoompiCommon'
import {connect} from 'scripts/store'

// HoCs should not be in render method since render will be called more than once
// This is to ensure that HoC is only created once
const CommonComponent = SoompiCommon(ArticleRender)

export class Article extends SoompiComponent {
  constructor(props) {
    super(props)
    let article = extractOrFormInitialData.call(this, 'article', placeHolders(1)[0])

    this.state = {
      article: article, // must have the same structure as the real data
      hasError: (this.isDataAvailable ? this.isDataAvailable.hasError : false),
      ads: null
    }
  }

  // Regenerate entire article including client-side only content such as ads
  fetchData = (postId, slug) => {
    window.scrollTo(0, 0)
    soompi.setLanguage(this.lang).getArticle({ id: postId }).promise.then((post) => {
      this.setState({ article: post })
      this.syncSideContent(post, slug)
    }).catch((e) => {
      ClientErrors({
        message: 'Article fetch failed.',
        error: e
      })
      this.setState({hasError: true})
    })
  }

  // Generate article's client-side only content such as ads
  syncSideContent = (post, slug) => {
    // Verify the slug if its correct
    if (decodeURIComponent(post.slug) !== slug) {
      this.props.history.push(`/article/${post.id}/${post.slug}`)
    } else {
      this.setState({ ads: this.setAds() })
    }

    this.initiateEmbeds()
  }

  componentDidMount() {
    const { params } = this.props.match
    const slug = params['slug']
    const postId = params['id']
    const post = this.state.article
    const ssrArticleLoaded = post && post.id === postId

    if (ssrArticleLoaded) {
      this.syncSideContent(this.state.article, slug)
    } else {
      this.fetchData(postId, slug)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match) {
      const { params } = nextProps.match
      const slug = params['slug']
      const postId = params['id']
      // clear the content if clicked another article from the same page
      this.setState({article: placeHolders(1)[0], ads: null}, () => {
        this.fetchData(postId, slug)
      })
    }
  }

  setAds = () => {
    return { adSideTop: {
      desktop: { id: '1525945435989-0', slot: 'Desktop.Article.EN.300x250', width: 300, height: 250 },
      mobile: { id: '1525945240254-0', slot: 'MW.Article.EN.300x250', width: 300, height: 250 }
    },
    adSideBottom: {
      desktop: { id: '1528888394546-0', slot: 'Desktop.Article.EN.300x600', width: 300, height: 600 },
      mobile: null
    },
    // Ad after article content
    adLead: {
      desktop: { id: '1528274026780-0', slot: 'Desktop.Article.EN.970x250', width: 970, height: 250 },
      mobile: { id: '1528273128712-0', slot: 'MW.Article.EN.320x100', width: 320, height: 100 }
    },
    // Ad after article title
    adHeader: {
      mobile: { id: '1578996134484-0', slot: 'MW.Article.EN.300x250.ATF', width: 300, height: 250 }
    },
    // Ad before comment
    adBeforeComment: {
      desktop: { id: '1582539788714-0', slot: 'Desktop.Article.EN.300x250.2', width: 300, height: 250 },
      mobile: { id: '1581055487720-0', slot: 'MW.Article.EN.300x250.2', width: 300, height: 250 }
    }}
  }

  initiateEmbeds() {
    const file = new FileLoader()
    const promises = [
      file.load('https://www.instagram.com/embed.js', 'instagram-embed'),
      file.load('https://platform.twitter.com/widgets.js', 'twitter-embed'),
      file.load('https://assets.tumblr.com/post.js', 'tumblr-embed'),
      file.load('https://connect.facebook.net/en_US/sdk.js', 'facebook-jssdk')
    ]

    Promise.all(promises).catch((e) => {
      console.error(e.message())
      throw new Error('[ERROR] Problem fetching one of the 3rd party embed files')
    }).then(() => {
      twttr && twttr.widgets.load()
      instgrm && instgrm.Embeds.process()
      FB && FB.init({xfbml: true, version: 'v2.5'})
    }).catch((e) => {
      console.error(e.message())
    })
  }

  render() {
    const finalProps = Object.assign({...this.state}, {...this.props})

    return (
      <CommonComponent ssr={false} {...finalProps} />
    )
  }
}

const stateToProps = ({ section, articleTag }) => {
  return { section, articleTag }
}

export default connect(stateToProps)(Article)



// WEBPACK FOOTER //
// ./assets/js/components/article.jsx